import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import _ from 'lodash';

const financialStatementFiltersReducer = (state = initialState.financialStatementsFilters, action) => {
	switch (action.type) {
		case types.SET_FINANCIAL_STATEMENT_MULTIPLE_MENU_FILTER: {
			if (action.filters) {
				return {
					...state,
					[action.filters.name]: action.value
				};
			}
			return state; // Return the current state if action.filters is not defined
		}

		case types.CLEAR_FINANCIAL_STATEMENT_MENU_FILTERS: {
			let filters = {...state};
			filters = {};
			return filters;
		}
		// other cases
		default:
			return state;
	}
};

export default financialStatementFiltersReducer;
